﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoanCalcView = void 0;
const modalCom = require("@ivanlog/gs-com-modal_dialogs");
const com = require("../tmpls");
const AppSV_1 = require("../../AppSV");
const BiMath_1 = require("../../BiMath");
const LoanCalcViewController_1 = require("./loanCalcViewClasses/LoanCalcViewController");
class LoanCalcView extends com.CmpLoanCalc {
    constructor() {
        super();
        this.cacheTransferValueUSDL = BigInt(0);
        this._app = AppSV_1.AppSV.Inst;
        this._control = new LoanCalcViewController_1.LoanCalcViewController(this);
        globalThis.refreshHandler = () => __awaiter(this, void 0, void 0, function* () { return this.refreshAsync(); });
        this._app.chain.onChangeAccount.addHandler(() => __awaiter(this, void 0, void 0, function* () {
            yield this.refreshAsync();
        }));
        this.ctrls.btnSVInfoToggle.onclick = () => {
            if (this.ctrls.btnSVInfoToggle.text == "+") {
                this.ctrls.btnSVInfoToggle.text = "–";
                this.ctrls.blockSVInfoAdditional.show();
            }
            else {
                this.ctrls.btnSVInfoToggle.text = "+";
                this.ctrls.blockSVInfoAdditional.hide();
            }
        };
        this.ctrls.btnConnectWallet.onclick = () => __awaiter(this, void 0, void 0, function* () {
            const modalWalletError = new modalCom.DialogOk("It looks like your browser doesn't have a wallet installed. Please use a browser with a functioning MetaMask or Rabby extension", "Information");
            const modalAgreement = new modalCom.DialogOk("", "Information");
            modalAgreement.ctrls.body.html = "Please confirm that you have read and agree to the <a href=\"https://up.docs.plusx.app/?folder=Smart%20Vaults&article=Disclaimer%2C%20Risks\" target='_blank'>Terms of Use</a> by clicking the button below.";
            modalAgreement.ctrls.body.onclick = (e) => e.stopPropagation();
            const result = yield modalAgreement.show();
            if (result != modalCom.ModalDialogResult.Ok)
                return;
            this.ctrls.btnConnectWallet.disable();
            try {
                const account = yield this._app.chain.getAccountAsync();
                if (!account) {
                    this.ctrls.btnConnectWallet.enable();
                    modalWalletError.show();
                    return;
                }
                yield this._app.chain.refreshSmartVaults();
                this.ctrls.btnConnectWallet.enable();
                yield this.refreshAsync(true);
            }
            catch (error) {
                this.ctrls.btnConnectWallet.enable();
                modalWalletError.show();
                throw error;
            }
        });
        ///*******************Borrow*******************
        let cacheCollValue = BiMath_1.BiMath.Zero;
        let cacheLoanValue = BiMath_1.BiMath.Zero;
        let needLoanValue = BiMath_1.BiMath.Zero;
        let borrowLoanValue = BiMath_1.BiMath.Zero;
        const fillDepositOverview = () => {
            const fee = this._calcFeeFunc(needLoanValue, this._llBorrowFee);
            const totalFee = needLoanValue * this._llBorrowFee / BiMath_1.BiMath.Decimal + fee;
            if (this.ctrls.iDepositValuePLS.value == "" || this.ctrls.iBorrowValueUSDL.value == "") {
                this._control.borrowReset();
                return;
            }
            if (cacheCollValue != BiMath_1.BiMath.Zero && needLoanValue != BiMath_1.BiMath.Zero)
                this.ctrls.btnBorrowSubmit.enable();
            else
                this.ctrls.btnBorrowSubmit.disable();
            if (!this._app.chain.account)
                this.ctrls.btnBorrowSubmit.disable();
            borrowLoanValue = needLoanValue - totalFee;
            this.ctrls.lTxDepositBorrow.text = BiMath_1.BiMath.ToEth(borrowLoanValue);
            this.ctrls.lTxDepositLoan.text = BiMath_1.BiMath.ToEth(needLoanValue);
            this.ctrls.lTxDepositFee.text = BiMath_1.BiMath.ToEth(totalFee);
            this.ctrls.lTxDepositValue.text = BiMath_1.BiMath.ToEth(cacheCollValue);
        };
        this.ctrls.iDepositValuePLS.el.addEventListener('input', () => __awaiter(this, void 0, void 0, function* () {
            const info = this._selectedVS.getInfo();
            let value = this._clearValueFunc(this.ctrls.iDepositValuePLS.value);
            if (value === false) {
                this.ctrls.iDepositValuePLS.value = BiMath_1.BiMath.ToEth(cacheCollValue);
                return;
            }
            cacheCollValue = BiMath_1.BiMath.ToBI(value);
            needLoanValue = cacheCollValue * BiMath_1.BiMath.Decimal20 / BiMath_1.BiMath.ToBI(info.FCRIndex);
            const fee = this._calcFeeFunc(needLoanValue, this._llBorrowFee);
            const totalFee = needLoanValue * this._llBorrowFee / BiMath_1.BiMath.Decimal + fee;
            cacheLoanValue = needLoanValue - totalFee;
            if (value == "")
                this.ctrls.iBorrowValueUSDL.value = "";
            else
                this.ctrls.iBorrowValueUSDL.value = BiMath_1.BiMath.ToEth(cacheLoanValue);
            fillDepositOverview();
        }));
        this.ctrls.iBorrowValueUSDL.el.addEventListener('input', () => __awaiter(this, void 0, void 0, function* () {
            const info = this._selectedVS.getInfo();
            let value = this._clearValueFunc(this.ctrls.iBorrowValueUSDL.value);
            if (value === false) {
                this.ctrls.iBorrowValueUSDL.value = BiMath_1.BiMath.ToEth(cacheLoanValue);
                return;
            }
            cacheLoanValue = BiMath_1.BiMath.ToBI(value);
            needLoanValue = this._calcOutLoanValue(cacheLoanValue);
            cacheCollValue = needLoanValue * BiMath_1.BiMath.ToBI(info.FCRIndex) / BiMath_1.BiMath.Decimal20;
            if (value == "")
                this.ctrls.iDepositValuePLS.value = "";
            else
                this.ctrls.iDepositValuePLS.value = BiMath_1.BiMath.ToEth(cacheCollValue);
            fillDepositOverview();
        }));
        this.ctrls.btnDepositMax.onclick = this.ctrls.btnBorrowMax.onclick = () => __awaiter(this, void 0, void 0, function* () {
            this.ctrls.btnBorrowMax.disable();
            this.ctrls.btnDepositMax.disable();
            const balance = yield this._app.chain.getBalanceEth();
            this.ctrls.btnBorrowMax.enable();
            this.ctrls.btnDepositMax.enable();
            if (!balance)
                return;
            const info = this._selectedVS.getInfo();
            cacheCollValue = BiMath_1.BiMath.ToBI(balance);
            needLoanValue = cacheCollValue * BiMath_1.BiMath.Decimal20 / BiMath_1.BiMath.ToBI(info.FCRIndex);
            const fee = this._calcFeeFunc(needLoanValue, this._llBorrowFee);
            const totalFee = needLoanValue * this._llBorrowFee / BiMath_1.BiMath.Decimal + fee;
            cacheLoanValue = needLoanValue - totalFee;
            this.ctrls.iDepositValuePLS.value = BiMath_1.BiMath.ToEth(cacheCollValue);
            this.ctrls.iBorrowValueUSDL.value = BiMath_1.BiMath.ToEth(cacheLoanValue);
            fillDepositOverview();
        });
        this.ctrls.btnBorrowSubmit.onclick = () => __awaiter(this, void 0, void 0, function* () {
            const result = yield this._control.awaitInLockUIAsync(this._selectedVS.borrowAsync(BiMath_1.BiMath.ToEth(cacheCollValue), BiMath_1.BiMath.ToEth(this._llBorrowFee), BiMath_1.BiMath.ToEth(borrowLoanValue)));
            if (result) {
                this._successFunc();
                this._control.borrowReset();
                yield this.refreshAsync();
            }
        });
        ///*******************Repay*******************
        let cacheRepayValue = BiMath_1.BiMath.Zero;
        let repayCollValue = BiMath_1.BiMath.Zero;
        const fillRepayOverview = () => {
            const info = this._selectedVS.getInfo();
            if (cacheRepayValue > BiMath_1.BiMath.ToBI(info.debt)) {
                cacheRepayValue = BiMath_1.BiMath.ToBI(info.debt);
                this.ctrls.iRepayValueUSDL.value = BiMath_1.BiMath.ToEth(cacheRepayValue);
            }
            if (this.ctrls.iRepayValueUSDL.value == "") {
                this._control.repayReset();
                return;
            }
            if (cacheRepayValue != BiMath_1.BiMath.Zero)
                this.ctrls.btnRepaySubmit.enable();
            else
                this.ctrls.btnRepaySubmit.disable();
            repayCollValue = cacheRepayValue * BiMath_1.BiMath.ToBI(info.FCRIndex) / BiMath_1.BiMath.Decimal20;
            this.ctrls.lTxRepayColl.text = BiMath_1.BiMath.ToEth(repayCollValue);
            this.ctrls.lTxRepayValue.text = BiMath_1.BiMath.ToEth(cacheRepayValue);
        };
        this.ctrls.iRepayValueUSDL.el.addEventListener('input', () => __awaiter(this, void 0, void 0, function* () {
            let value = this._clearValueFunc(this.ctrls.iRepayValueUSDL.value);
            if (value === false) {
                this.ctrls.iRepayValueUSDL.value = BiMath_1.BiMath.ToEth(cacheRepayValue);
                return;
            }
            cacheRepayValue = BiMath_1.BiMath.ToBI(value);
            fillRepayOverview();
        }));
        this.ctrls.btnRepayMax.onclick = () => __awaiter(this, void 0, void 0, function* () {
            this.ctrls.btnRepayMax.disable();
            const usdlBalance = yield this._app.chain.usdlToken.balanceOf(this._app.chain.account);
            this.ctrls.btnRepayMax.enable();
            if (!usdlBalance)
                return;
            cacheRepayValue = BiMath_1.BiMath.ToBI(usdlBalance);
            this.ctrls.iRepayValueUSDL.value = BiMath_1.BiMath.ToEth(cacheRepayValue);
            fillRepayOverview();
        });
        this.ctrls.btnRepaySubmit.onclick = () => __awaiter(this, void 0, void 0, function* () {
            const approveResult = yield this._control.awaitInLockUIAsync(this._app.chain.usdlToken.approve(this._selectedVS.address, BiMath_1.BiMath.ToEth(cacheRepayValue)));
            if (!approveResult)
                return;
            const result = yield this._control.awaitInLockUIAsync(this._selectedVS.repayDebtAsync(BiMath_1.BiMath.ToEth(cacheRepayValue), BiMath_1.BiMath.ToEth(repayCollValue)));
            if (result) {
                this._successFunc();
                this._control.repayReset();
                yield this.refreshAsync();
            }
        });
        ///*******************Tokenize*******************
        let cacheTokenizeValue = BiMath_1.BiMath.Zero;
        let minTokenizeValue = BiMath_1.BiMath.Zero;
        const fillTokenizeOverview = () => {
            const info = this._selectedVS.getInfo();
            if (cacheTokenizeValue > BiMath_1.BiMath.ToBI(info.debt)) {
                cacheTokenizeValue = BiMath_1.BiMath.ToBI(info.debt);
                this.ctrls.iTokenizeValueUSDL.value = BiMath_1.BiMath.ToEth(cacheTokenizeValue);
            }
            if (this.ctrls.iTokenizeValueUSDL.value == "") {
                this._control.tokenizeReset();
                return;
            }
            cacheDetokenizeValue = BiMath_1.BiMath.Zero;
            this._control.detokenizeReset();
            this.ctrls.blockTokenizeOverview.show();
            if (cacheTokenizeValue != BiMath_1.BiMath.Zero)
                this.ctrls.btnTokenizeSubmit.enable();
            else
                this.ctrls.btnTokenizeSubmit.disable();
            const token = cacheTokenizeValue * BiMath_1.BiMath.Decimal20 / BiMath_1.BiMath.ToBI(info.redeemDeltaDebtIndex);
            const fee = token * BigInt(3) / BigInt(1000);
            minTokenizeValue = token - fee;
            this.ctrls.lTokenizeTxLoan.text = BiMath_1.BiMath.ToEth(cacheTokenizeValue);
            this.ctrls.lTokenizeTxMint.text = BiMath_1.BiMath.ToEth(token);
            this.ctrls.lTokenizeTxFee.text = BiMath_1.BiMath.ToEth(fee);
        };
        this.ctrls.iTokenizeValueUSDL.el.addEventListener('input', () => __awaiter(this, void 0, void 0, function* () {
            let value = this._clearValueFunc(this.ctrls.iTokenizeValueUSDL.value);
            if (value === false) {
                this.ctrls.iTokenizeValueUSDL.value = BiMath_1.BiMath.ToEth(cacheTokenizeValue);
                return;
            }
            cacheTokenizeValue = BiMath_1.BiMath.ToBI(value);
            fillTokenizeOverview();
        }));
        this.ctrls.btnTokenizeMax.onclick = () => __awaiter(this, void 0, void 0, function* () {
            cacheTokenizeValue = BiMath_1.BiMath.ToBI(this._selectedVS.getInfo().debt);
            this.ctrls.iTokenizeValueUSDL.value = BiMath_1.BiMath.ToEth(cacheTokenizeValue);
            fillTokenizeOverview();
        });
        this.ctrls.btnTokenizeSubmit.onclick = () => __awaiter(this, void 0, void 0, function* () {
            if (cacheTokenizeValue == BiMath_1.BiMath.Zero)
                return;
            const result = yield this._control.awaitInLockUIAsync(this._selectedVS.tokenizeAsync(BiMath_1.BiMath.ToEth(cacheTokenizeValue), BiMath_1.BiMath.ToEth(minTokenizeValue)));
            if (result) {
                this._successFunc();
                this._control.tokenizeReset();
                yield this.refreshAsync();
            }
        });
        ///*******************Detokenize*******************
        let cacheDetokenizeValue = BiMath_1.BiMath.Zero;
        let loanDetokenizeValue = BiMath_1.BiMath.Zero;
        let collDetokenizeValue = BiMath_1.BiMath.Zero;
        const fillDetokenizeOverview = () => {
            const info = this._selectedVS.getInfo();
            if (cacheDetokenizeValue > BiMath_1.BiMath.ToBI(info.plsvBalance)) {
                cacheDetokenizeValue = BiMath_1.BiMath.ToBI(info.plsvBalance);
                this.ctrls.iDetokenizeValueUSDL.value = BiMath_1.BiMath.ToEth(cacheDetokenizeValue);
            }
            if (this.ctrls.iDetokenizeValueUSDL.value == "") {
                this._control.detokenizeReset();
                return;
            }
            cacheTokenizeValue = BiMath_1.BiMath.Zero;
            this._control.tokenizeReset();
            this.ctrls.blockDetokenizeOverview.show();
            if (cacheDetokenizeValue != BiMath_1.BiMath.Zero)
                this.ctrls.btnDetokenizeSubmit.enable();
            else
                this.ctrls.btnDetokenizeSubmit.disable();
            const fee = cacheDetokenizeValue * BigInt(3) / BigInt(1000);
            const token = cacheDetokenizeValue - fee;
            loanDetokenizeValue = token * BiMath_1.BiMath.ToBI(info.redeemDeltaDebtIndex) / BiMath_1.BiMath.Decimal20;
            collDetokenizeValue = loanDetokenizeValue * BiMath_1.BiMath.ToBI(info.FCRIndex) / BiMath_1.BiMath.Decimal20;
            this.ctrls.lDetokenizeTxFee.text = BiMath_1.BiMath.ToEth(fee);
            this.ctrls.lDetokenizeTxBurn.text = BiMath_1.BiMath.ToEth(cacheDetokenizeValue - fee);
            this.ctrls.lDetokenizeTxLoan.text = BiMath_1.BiMath.ToEth(loanDetokenizeValue);
        };
        this.ctrls.iDetokenizeValueUSDL.el.addEventListener('input', () => __awaiter(this, void 0, void 0, function* () {
            let value = this._clearValueFunc(this.ctrls.iDetokenizeValueUSDL.value);
            if (value === false) {
                this.ctrls.iDetokenizeValueUSDL.value = BiMath_1.BiMath.ToEth(cacheDetokenizeValue);
                return;
            }
            cacheDetokenizeValue = BiMath_1.BiMath.ToBI(value);
            fillDetokenizeOverview();
        }));
        this.ctrls.btnDetokenizeMax.onclick = () => __awaiter(this, void 0, void 0, function* () {
            cacheDetokenizeValue = BiMath_1.BiMath.ToBI(this._selectedVS.getInfo().plsvBalance);
            this.ctrls.iDetokenizeValueUSDL.value = BiMath_1.BiMath.ToEth(cacheDetokenizeValue);
            fillDetokenizeOverview();
        });
        this.ctrls.btnDetokenizeSubmit.onclick = () => __awaiter(this, void 0, void 0, function* () {
            if (cacheDetokenizeValue == BiMath_1.BiMath.Zero)
                return;
            const result = yield this._control.awaitInLockUIAsync(this._selectedVS.detokenizeAsync(BiMath_1.BiMath.ToEth(cacheDetokenizeValue), BiMath_1.BiMath.ToEth(loanDetokenizeValue), BiMath_1.BiMath.ToEth(collDetokenizeValue)));
            if (result) {
                this._successFunc();
                this._control.detokenizeReset();
                yield this.refreshAsync();
            }
        });
        ///*******************Claim*******************
        const fillClaimOverview = () => {
            const info = this._selectedVS.getInfo();
            let collClaim = BiMath_1.BiMath.ToBI(info.debt) * BiMath_1.BiMath.ToBI(info.totalLiqidatedColl) / BiMath_1.BiMath.ToBI(info.totalDebt);
            if (collClaim > BiMath_1.BiMath.Zero)
                this.ctrls.btnClaimSubmit.enable();
            else
                this.ctrls.btnClaimSubmit.disable();
            this.ctrls.lTxClaimValue.text = BiMath_1.BiMath.ToEth(collClaim);
        };
        this.ctrls.btnClaimSubmit.onclick = () => __awaiter(this, void 0, void 0, function* () {
            const result = yield this._control.awaitInLockUIAsync(this._selectedVS.claimCollateralAsync());
            if (result) {
                this._successFunc();
                this._control.claimReset();
                yield this.refreshAsync();
            }
        });
        this.ctrls.btnTabClaim.el.addEventListener("click", () => fillClaimOverview());
        ///*******************Transfer*******************
        this.ctrls.iTransferValueUSDL.el.addEventListener('input', () => __awaiter(this, void 0, void 0, function* () {
            let value = this._clearValueFunc(this.ctrls.iTransferValueUSDL.value);
            if (value === false) {
                this.ctrls.iTransferValueUSDL.value = BiMath_1.BiMath.ToEth(this.cacheTransferValueUSDL);
                return;
            }
            this.cacheTransferValueUSDL = BiMath_1.BiMath.ToBI(value);
            this._fillTransferOverview();
        }));
        this.ctrls.btnTransferMax.onclick = () => __awaiter(this, void 0, void 0, function* () {
            if (!this._app.chain.account)
                return;
            this.ctrls.btnTransferMax.disable();
            const usdlBalance = yield this._app.chain.usdlToken.balanceOf(this._app.chain.account);
            this.ctrls.btnTransferMax.enable();
            if (!usdlBalance)
                return;
            this.cacheTransferValueUSDL = BiMath_1.BiMath.ToBI(usdlBalance);
            const info = this._selectedVS.getInfo();
            const debt = BiMath_1.BiMath.ToBI(info.debt);
            if (this.cacheTransferValueUSDL > debt)
                this.cacheTransferValueUSDL = debt;
            this.ctrls.iTransferValueUSDL.value = BiMath_1.BiMath.ToEth(this.cacheTransferValueUSDL);
            this.ctrls.lTxTransferOwnUsdl.text = BiMath_1.BiMath.ToEth(this.cacheTransferValueUSDL);
            this._fillTransferOverview();
        });
        ///*******************Transfer*******************
        this.ctrls.btnCalculateRedeemSubmit.onclick = () => __awaiter(this, void 0, void 0, function* () {
            const result = yield this._control.awaitInLockUIAsync(this._selectedVS.checkMainVaultChangesAsync());
            if (result) {
                this._successFunc();
                yield this.refreshAsync();
            }
        });
    }
    _successFunc() { new modalCom.DialogOk("The transaction was completed successfully.", "Information").show(); }
    _clearValueFunc(value) {
        if (value == "")
            return value;
        if (value.charAt(0) == ".")
            value = "0" + value;
        const regex = /^[0-9]+(\.[0-9]{0,18})?$/;
        //const regex = /^[0-9]+(\.[0-9]*)?$/;
        if (!regex.test(value))
            return false;
        return value;
    }
    _calcFeeFunc(loanBase, borrowRate) {
        const stage2 = BiMath_1.BiMath.ToBI("55.0");
        let fee = loanBase / BigInt(10); //0.1;
        if (fee > stage2) {
            fee = stage2;
            const fee_3stage = loanBase * borrowRate / BigInt(2) / BiMath_1.BiMath.Decimal;
            if (fee_3stage > fee)
                fee = fee_3stage;
        }
        return fee;
    }
    _calcOutLoanValue(loanTarget) {
        let outLoanValue = loanTarget;
        if (outLoanValue != BiMath_1.BiMath.Zero) {
            let i = BiMath_1.BiMath.Decimal;
            let inited = false;
            let step = BiMath_1.BiMath.ToBI("0.05");
            let toUp = true;
            for (let counter = 0; counter < 100; counter++) {
                outLoanValue = loanTarget * i / BiMath_1.BiMath.Decimal;
                const totalFee = outLoanValue * this._llBorrowFee / BiMath_1.BiMath.Decimal + this._calcFeeFunc(outLoanValue, this._llBorrowFee);
                if (outLoanValue < totalFee) {
                    outLoanValue = BiMath_1.BiMath.Zero;
                    break;
                }
                let baseLoan = outLoanValue - totalFee;
                if (baseLoan == BiMath_1.BiMath.Zero) {
                    outLoanValue = BiMath_1.BiMath.Zero;
                    break;
                }
                let index = loanTarget * BiMath_1.BiMath.Decimal / baseLoan;
                let indexStr = BiMath_1.BiMath.ToEth(index);
                if (indexStr.indexOf("0.9999999999999999") == 0) {
                    break;
                }
                if (!inited) {
                    inited = true;
                    step = BiMath_1.BiMath.ToBI("0.05");
                    if (index < BiMath_1.BiMath.Decimal)
                        toUp = false;
                    else
                        toUp = true;
                }
                if (toUp && index < BiMath_1.BiMath.Decimal) {
                    toUp = false;
                    step = step / BigInt(3);
                }
                else if (!toUp && index > BiMath_1.BiMath.Decimal) {
                    toUp = true;
                    step = step / BigInt(3);
                }
                if (toUp)
                    i += step;
                else
                    i -= step;
            }
        }
        return outLoanValue;
    }
    _createVaultSelector(vaultContract, id, price) {
        const info = vaultContract.getInfo();
        const item = new com.CmpSmartVaultSelector();
        const fcr = parseInt(parseFloat(BiMath_1.BiMath.ToEth(BiMath_1.BiMath.ToBI(info.FCRIndex) / BigInt(100))) * 1000 + "") / 1000 + "";
        const icr = parseInt(parseFloat(info.FCRIndex) * 100 * price + "") / 100 + "";
        item.ctrls.lFCR.text = fcr;
        item.ctrls.lICR.text = icr;
        item.ctrls.lSmartVaultId.text = info.name.substring(4);
        if (info.isLiquidated)
            item.addClass('closed');
        else if (info.closeVaultTimestamp != "0")
            item.addClass('closing');
        return item;
    }
    refreshAsync(firstTimeAfterConnect = false) {
        return __awaiter(this, void 0, void 0, function* () {
            const llBorrowFee = yield this._app.chain.llVaultManagerContract.getBorrowingRate();
            if (llBorrowFee)
                this._llBorrowFee = BiMath_1.BiMath.ToBI(llBorrowFee) * BiMath_1.BiMath.ToBI("1.1") / BiMath_1.BiMath.Decimal;
            else
                this._llBorrowFee = BiMath_1.BiMath.ToBI("0.1");
            //обновляем цену coll
            yield this._app.chain.priceKeeperPLS.getPriceAsync();
            const price = parseFloat(this._app.chain.priceKeeperPLS.getPriceCached());
            yield this._app.chain.refreshSmartVaults();
            let lastActiveTab = this._control.getActiveTab();
            if (lastActiveTab == this.ctrls.tabRedeemCalc)
                lastActiveTab = undefined;
            if (lastActiveTab == this.ctrls.tabClaim)
                lastActiveTab = undefined;
            //выводим список волтов
            this.ctrls.vaultSelector.html = '';
            const vaultsItems = new Array();
            let vsCounter = 1;
            let reselectIndex = -1;
            let reselectFCRIndex = BiMath_1.BiMath.Zero;
            const svSorted = [[], [], []];
            if (firstTimeAfterConnect)
                this._selectedVS = null;
            for (const vaultContract of this._app.chain.smartVaults) {
                const item = this._createVaultSelector(vaultContract, vsCounter, price);
                item.onclick = () => { for (const v of vaultsItems)
                    v.removeClass('selected'); this._selectVault(vaultContract, item); };
                if (item.hasClass('closed'))
                    svSorted[2].push(item);
                else if (item.hasClass('closing'))
                    svSorted[1].push(item);
                else
                    svSorted[0].push(item);
                vaultsItems.push(item);
                item.ctrls.vaultContract = vaultContract;
                if (this._selectedVS) {
                    if (this._selectedVS.address == vaultContract.address)
                        reselectIndex = vsCounter;
                }
                else if (firstTimeAfterConnect) {
                    const info = vaultContract.getInfo();
                    if (parseFloat(info.debt) > 0) {
                        if (reselectFCRIndex == BiMath_1.BiMath.Zero) {
                            reselectIndex = vsCounter;
                            reselectFCRIndex = BiMath_1.BiMath.ToBI(info.FCRIndex);
                        }
                        else if (BiMath_1.BiMath.ToBI(info.FCRIndex) < reselectFCRIndex) {
                            reselectIndex = vsCounter;
                            reselectFCRIndex = BiMath_1.BiMath.ToBI(info.FCRIndex);
                        }
                    }
                }
                vsCounter++;
            }
            //Выводим сортируя от активных до закрытых
            let firstSV;
            for (const vss of svSorted)
                for (const vs of vss) {
                    if (!firstSV)
                        firstSV = vs;
                    ;
                    this.ctrls.vaultSelector.append(vs);
                }
            //делаем настройки в зависимости есть ли подключение к кошельку
            if (!this._app.chain.account) {
                this.ctrls.btnTabClaim.disable();
                this.ctrls.btnTabPLSV.disable();
                this.ctrls.btnTabRepay.disable();
                this.ctrls.btnTabTransfer.disable();
                this.ctrls.btnBorrowMax.hide();
                this.ctrls.btnDepositMax.hide();
                this.ctrls.btnBorrowSubmit.disable();
                this.ctrls.blockConnectWallet.show();
            }
            else {
                this.ctrls.btnTabClaim.disable();
                this.ctrls.btnTabPLSV.enable();
                this.ctrls.btnTabRepay.enable();
                this.ctrls.btnTabTransfer.enable();
                this.ctrls.btnBorrowMax.show();
                this.ctrls.btnDepositMax.show();
                this.ctrls.btnBorrowSubmit.enable();
                this.ctrls.blockConnectWallet.hide();
            }
            if (reselectIndex >= 0)
                this._selectVault(this._app.chain.smartVaults[reselectIndex - 1], vaultsItems[reselectIndex - 1]);
            //если есть хоть 1 волт, выбираем его
            else if (firstSV)
                this._selectVault(firstSV.ctrls.vaultContract, firstSV);
            if (lastActiveTab)
                this._control.activeTab(lastActiveTab);
        });
    }
    _selectVault(vaultContract, item) {
        return __awaiter(this, void 0, void 0, function* () {
            this._selectedVS = vaultContract;
            item.addClass('selected');
            const info = vaultContract.getInfo();
            this.ctrls.lSVInfoYourLoan.text = info.debt;
            this.ctrls.lSVInfoYourColl.text = info.coll;
            this.ctrls.lSVInfoTotalLoan.text = info.totalDebt;
            this.ctrls.lSVInfoBalancePLSV.text = info.plsvBalance + " " + info.name;
            this.ctrls.lSVInfoSupplyPLSV.text = info.plsvSupply + " " + info.name;
            this.ctrls.lSVAddress.text = vaultContract.address;
            this.ctrls.btnAddPLSV.text = "Add " + info.name + " to Wallet";
            this.ctrls.btnAddPLSV.onclick = () => { this._app.chain.addTokenToWalletAsync(info.addrs, info.name, 18); };
            this.ctrls.lSVInfoDiffLoan.text = "-";
            //add selectedView
            const vaultSelected = new com.CmpSmartVaultSelected();
            item.el.classList.forEach(c => { if (c.indexOf("sv-cmp") < 0)
                vaultSelected.addClass(c); });
            vaultSelected.ctrls.lSmartVaultId.text = item.ctrls.lSmartVaultId.text;
            if (item.hasClass('closed'))
                vaultSelected.ctrls.lSmartVaultId.text += " - Closed";
            else if (item.hasClass('closing'))
                vaultSelected.ctrls.lSmartVaultId.text += " - Closing Soon";
            else
                vaultSelected.ctrls.lSmartVaultId.text += " - Active";
            vaultSelected.ctrls.lFCR.text = item.ctrls.lFCR.text;
            this.ctrls.blockVaultSelector.hide();
            vaultSelected.ctrls.btnToggle.onclick = () => {
                if (vaultSelected.ctrls.btnToggle.text == "+") {
                    vaultSelected.ctrls.btnToggle.text = "–";
                    this.ctrls.blockVaultSelector.show();
                }
                else {
                    vaultSelected.ctrls.btnToggle.text = "+";
                    this.ctrls.blockVaultSelector.hide();
                }
            };
            this.ctrls.vaultSelected.html = '';
            this.ctrls.vaultSelected.append(vaultSelected);
            const loadDiffAsyncFunc = () => __awaiter(this, void 0, void 0, function* () {
                const result = yield this._app.chain.diffCalc.searchDiff(vaultContract.address, 500);
                if (!result)
                    return;
                let debt = BiMath_1.BiMath.ToBI(result.debt_);
                let debtEth = BiMath_1.BiMath.ToEth((debt / BiMath_1.BiMath.Decimal / BigInt("1000")) * BiMath_1.BiMath.Decimal); // *BigInt("1000000000000000"));
                if (result.last_ == vaultContract.address)
                    this.ctrls.lSVInfoDiffLoan.text = debtEth + "k";
                else
                    this.ctrls.lSVInfoDiffLoan.text = ">" + debtEth + "k";
            });
            this.ctrls.lSVInfoClosing.show();
            this.ctrls.lSVInfoIsClosed.show();
            this._control.showAllTabs();
            let canTransfer = true;
            if (info.needExtSync) //требуется расчет редима
             {
                loadDiffAsyncFunc();
                canTransfer = false;
                this.ctrls.lSVInfoClosing.hide();
                this.ctrls.lSVInfoIsClosed.hide();
                this.ctrls.btnTabBorrow.hide();
                this.ctrls.btnTabRepay.hide();
                this.ctrls.btnTabTransfer.hide();
                this.ctrls.btnTabClaim.hide();
                this.ctrls.btnTabPLSV.hide();
                this.ctrls.btnTabRedeemCalc.enable();
                this._control.activeTab(this.ctrls.tabRedeemCalc);
                if (!this._app.chain.account) {
                    this.ctrls.tabRedeemCalc.hide();
                }
            }
            else if (info.isLiquidated) //ликвидирован
             {
                canTransfer = false;
                this.ctrls.lSVInfoClosing.hide();
                this.ctrls.btnTabBorrow.hide();
                this.ctrls.btnTabRepay.hide();
                this.ctrls.btnTabTransfer.hide();
                this.ctrls.btnTabClaim.enable();
                this.ctrls.btnTabRedeemCalc.hide();
                this._control.activeTab(this.ctrls.tabPLSV);
                if (!this._app.chain.account) {
                    this.ctrls.btnTabPLSV.hide();
                    this.ctrls.btnTabClaim.hide();
                    this._control.closeTab();
                }
            }
            else if (info.closeVaultTimestamp == "0") //норм работает
             {
                loadDiffAsyncFunc();
                this.ctrls.lSVInfoClosing.hide();
                this.ctrls.lSVInfoIsClosed.hide();
                this.ctrls.btnTabClaim.hide();
                this.ctrls.btnTabRedeemCalc.hide();
                if (info.debt == "0.0") {
                    canTransfer = false;
                    this.ctrls.btnTabRepay.hide();
                    this.ctrls.btnTabTransfer.hide();
                }
                this._control.activeTab(this.ctrls.tabBorrow);
            }
            else //ликвидируется
             {
                loadDiffAsyncFunc();
                this.ctrls.lSVInfoIsClosed.hide();
                this.ctrls.btnTabBorrow.hide();
                this.ctrls.btnTabClaim.hide();
                this.ctrls.btnTabRedeemCalc.hide();
                var closeDate = new Date(parseFloat(info.closeVaultTimestamp) * 1000 + 90 * 24 * 60 * 60 * 1000);
                const month = closeDate.toLocaleString('default', { month: 'long' });
                this.ctrls.lSVInfoCloseDate.text = `${month.charAt(0).toUpperCase() + month.slice(1)} ${closeDate.getDate()} ${closeDate.getFullYear()}`;
                this._control.activeTab(this.ctrls.tabRepay);
                if (!this._app.chain.account)
                    this.ctrls.tabRepay.hide();
            }
            this.ctrls.lSVInfoRedeemIndex.text = parseInt(parseFloat(info.redeemDeltaDebtIndex) * 100 + "") / 100 + "";
            if (canTransfer) {
                const price = parseFloat(this._app.chain.priceKeeperPLS.getPriceCached());
                const vaultsItems = new Array();
                let vsCounter = 1;
                this.ctrls.transferVaultSelector.html = '';
                for (const vaultContract of this._app.chain.smartVaults) {
                    if (vaultContract.address == this._selectedVS.address) {
                        vsCounter++;
                        continue;
                    }
                    const vaultInfo = vaultContract.getInfo();
                    if (vaultInfo.isLiquidated)
                        continue; //скипаем те что ликвидированы
                    if (vaultInfo.closeVaultTimestamp != "0")
                        continue; //скипаем те что что на ликвидацию
                    const item = this._createVaultSelector(vaultContract, vsCounter, price);
                    item.onclick = () => {
                        for (const v of vaultsItems)
                            v.removeClass('selected');
                        item.addClass('selected');
                        this.selectedVSToTransfer = vaultContract;
                        this._fillTransferOverview();
                    };
                    this.ctrls.transferVaultSelector.append(item);
                    vaultsItems.push(item);
                    vsCounter++;
                }
            }
        });
    }
    _fillTransferOverview() {
        const borrowFeeDec = this._llBorrowFee;
        const feeChangerIndex = BiMath_1.BiMath.ToBI("0.5");
        const atInfo = this._selectedVS.getInfo();
        const toInfo = this.selectedVSToTransfer.getInfo();
        let ownsUSDL = this.cacheTransferValueUSDL;
        const currentLoan = BiMath_1.BiMath.ToBI(atInfo.debt);
        if (ownsUSDL > currentLoan) {
            ownsUSDL = currentLoan;
            this.cacheTransferValueUSDL = ownsUSDL;
            this.ctrls.iTransferValueUSDL.value = BiMath_1.BiMath.ToEth(this.cacheTransferValueUSDL);
            this.ctrls.lTxTransferOwnUsdl.text = BiMath_1.BiMath.ToEth(this.cacheTransferValueUSDL);
        }
        const usdlForFlash = currentLoan - ownsUSDL;
        const flashFee = usdlForFlash * BiMath_1.BiMath.ToBI("0.005") / BiMath_1.BiMath.Decimal;
        const minLoan = currentLoan + flashFee;
        let needGetLoan = minLoan;
        for (let i = 1; i < 10000; i++) {
            const index = BiMath_1.BiMath.Decimal * BigInt(i) / BigInt(1000);
            const additionalLoan = minLoan * index / BiMath_1.BiMath.Decimal;
            const fullLoan = additionalLoan + minLoan;
            const fee = this._calcFeeFunc(fullLoan, borrowFeeDec) * feeChangerIndex / BiMath_1.BiMath.Decimal
                + fullLoan * borrowFeeDec / BiMath_1.BiMath.Decimal; //*BigInt(10);
            if (additionalLoan > fee) {
                needGetLoan = fullLoan;
                break;
            }
        }
        const svFee = this._calcFeeFunc(needGetLoan, borrowFeeDec) * feeChangerIndex / BiMath_1.BiMath.Decimal;
        const llFee = needGetLoan * borrowFeeDec / BiMath_1.BiMath.Decimal;
        const willReturnColl = BiMath_1.BiMath.ToBI(atInfo.coll);
        // needGetLoan = currentLoan + flashFee + svFee + llFee
        const needGetColl = needGetLoan * BiMath_1.BiMath.ToBI(toInfo.FCRIndex) / BiMath_1.BiMath.Decimal20;
        let needAddColl = BiMath_1.BiMath.Zero;
        if (needGetColl > willReturnColl)
            needAddColl = needGetColl - willReturnColl;
        this.ctrls.lTxTransferToAddr.text = toInfo.addrs;
        this.ctrls.lTxTransferToFCR.text = BiMath_1.BiMath.ToEth(BiMath_1.BiMath.ToBI(toInfo.FCRIndex) / BigInt(100));
        if (needGetColl > willReturnColl)
            this.ctrls.lTxTransferAddColl.text = BiMath_1.BiMath.ToEth(needAddColl);
        else
            this.ctrls.lTxTransferAddColl.text = "0";
        this.ctrls.lTxTransferFee.text = BiMath_1.BiMath.ToEth(llFee + svFee);
        this.ctrls.lTxTransferFlashLoanFee.text = BiMath_1.BiMath.ToEth(flashFee);
        this.ctrls.lTxTransferOwnUsdl.text = BiMath_1.BiMath.ToEth(ownsUSDL);
        //Ты возвращаем юсдл а не плс, подумай как сделать перерасчет
        // if (needGetColl<willReturnColl) this.ctrls.lTxTransferCollReturn.text = BiMath.ToEth(willReturnColl-needGetColl); else
        //     this.ctrls.lTxTransferCollReturn.text = "0";
        this.ctrls.lTxTransferNewLoanAmount.text = BiMath_1.BiMath.ToEth(needGetLoan + BiMath_1.BiMath.ToBI(toInfo.debt));
        this.ctrls.btnTransferSubmit.enable();
        this.ctrls.btnTransferSubmit.onclick = () => __awaiter(this, void 0, void 0, function* () {
            const balance = BiMath_1.BiMath.ToBI(yield this._app.chain.getBalanceEth());
            if (balance < needAddColl) {
                new modalCom.DialogOk("Not enough PLS. Mint and trade PLSV tokens to transfer between Smart Vaults.", "Information").show();
                return;
            }
            if (ownsUSDL > BiMath_1.BiMath.Zero) {
                const approveResult = yield this._control.awaitInLockUIAsync(this._app.chain.usdlToken.approve(this._app.chain.smartVaultManager.address, BiMath_1.BiMath.ToEth(ownsUSDL)));
                if (!approveResult)
                    return;
            }
            const result = yield this._control.awaitInLockUIAsync(this._app.chain.smartVaultManager.changeSmartVaultAsync(BiMath_1.BiMath.ToEth(needAddColl), atInfo.addrs, toInfo.addrs, BiMath_1.BiMath.ToEth(ownsUSDL), BiMath_1.BiMath.ToEth(borrowFeeDec)));
            if (result) {
                this._successFunc();
                this._control.transferReset();
                this._control.activeTab(this.ctrls.tabBorrow);
                yield this.refreshAsync();
            }
        });
    }
}
exports.LoanCalcView = LoanCalcView;
//# sourceMappingURL=LoanCalcView.js.map